var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.statusStyle != '')?_c('v-chip',{staticClass:"table-label",style:(_vm.statusStyle),attrs:{"small":"","label":"","dark":""}},[_c('div',[_vm._v(_vm._s(_vm.$t(_vm.statusText)))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }